import { Provider } from 'react-redux';
import React from 'react';
import flowsStore from '../redux/store';
import FlowsContext from './flowsReduxContext';
import FlowsStorageProvider from './FlowsStorageProvider';

interface Props {
  AppShell: React.FC<React.PropsWithChildren<unknown>>;
}

const FlowsProvider: React.FC<React.PropsWithChildren<Props>> = ({
  AppShell,
  children,
}) => {
  return (
    <Provider store={flowsStore} context={FlowsContext}>
      <FlowsStorageProvider AppShell={AppShell}>
        {children}
      </FlowsStorageProvider>
    </Provider>
  );
};

export default FlowsProvider;
